import { loadItems } from "../hooks/itemstore"; 

function Browse(props) {
    let items = loadItems();
    console.log(items);

    // Use today for date comparisons further down
    let currentDate = new Date();
    currentDate.setHours(0,0,0,0);
    let twoWeeksOut = new Date(Date.now() + 12096e5); // 14 days in milliseconds
    // console.log("current date "+ currentDate);
    // console.log("two weeks out "+ twoWeeksOut);

    function handleViewItem(event) {
        event.preventDefault();
        console.log("Browse - Selected "+event.target.id);
        props.setSelectedItem(event.target.id);  
        props.setActiveTab("add");
    }

    if (Object.keys(items).length === 0) {
        props.setActiveTab("docs");
        return (
            <div>
                <h3>No items to browse</h3>
            </div>
        );
    }

    // create map of display categories with value as array of array
    // ex: disp_categories = {<category>: [["Benefit1", "ShortName1", "expires1"],["Benefit2", "ShortName2", "expires2"],...]}
    let disp_categories = new Map();
    // console.log("item count: "+Object.keys(items).length);
    for (const [key, thisItem] of Object.entries(items)) {
        let shortname = thisItem.shortname;
        for (let b = 0; b < thisItem.benefits.length; b++) {
            let benefitText = thisItem.benefits[b].benefit;
            let expirationDate = thisItem.benefits[b].expirationDate;
            if (expirationDate) {
                const expirationDate_date = new Date(expirationDate);
                // If expires within 2 weeks, show as red
                if (expirationDate_date < twoWeeksOut) {
                    expirationDate = <span className="expireSoon"> - through {expirationDate}</span>;
                } else {
                    expirationDate = <span> - through {expirationDate}</span>;
                }
            }
            let benefitShortnameArray = [benefitText, shortname, expirationDate];
            let categories = thisItem.benefits[b].categories.split("\n");
            for (let c = 0; c < categories.length; c++) {
                if (categories[c].trim().length > 0) {
                    if (disp_categories.has(categories[c])) {
                        let currentBenefits = disp_categories.get(categories[c]);
                        // console.log(categories[c]+" currentB: "+currentBenefits);
                        currentBenefits.push(benefitShortnameArray);
                        disp_categories.set(categories[c], currentBenefits);
                    } else {
                        disp_categories.set(categories[c], [benefitShortnameArray]);
                    }
                }
            }
        }
    }

    console.log(disp_categories);
    console.log("painted Browse");

    return (
        <div>
            {/* <ul>
                {Object.keys(items).map((key, index) => (
                    <li key={key}><a id={key} href="#" onClick={handleViewItem}>{key}</a> - {items[key]["description"]}</li>
                ))}
            </ul>
            <hr></hr>
            {Object.keys(disp_categories).map((key, index) => (
                <div key={key}>
                    {key}
                </div>  
            ))}
            <hr></hr> */}
            <h4>Benefits by Category</h4>
            {   /* iterate a map instead of an object */
                [...disp_categories.keys()].sort().map(category => (
                    <div className="browseCategory" key={category}>
                        {category}
                        {disp_categories.get(category).map(benefit => (
                            <div className="browseBenefit" key={benefit[0]+benefit[1]}>
                                {benefit[0]} {benefit[2]} - <a id={benefit[1]} href="#" onClick={handleViewItem}>{benefit[1]}</a>
                            </div>
                        ))}
                    </div>
                ))
            }
            {/* Might be good to list all cards separately */}
            <hr></hr>
            <h4>Card List</h4>
            <ul>
                {Object.keys(items).map((key, index) => (
                    <li key={key}><a id={key} href="#" onClick={handleViewItem}>{key}</a> - {items[key]["description"]}</li>
                ))}
            </ul>
        </div>
    );
}

export default Browse;